import { ArrowLeft2 } from 'iconsax-react';
import { useNavigate } from 'react-router';
import { ForgotPasswordForm, type ForgotPasswordFormData } from '@/components/auth/forgot-password-form';
import { BrandLogo } from '@/components/common/brand-logo';
import useResetPassword from '@/hooks/auth/use-reset-password';
import useUserPlatform from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import { addToast } from '@/stores/toast';

export default function ForgotPasswordRoute() {
  const navigate = useNavigate();
  const { isEmbedded } = useUserPlatform();
  const { mutateAsync: resetPassword, isPending } = useResetPassword();

  async function handleSubmit(data: ForgotPasswordFormData) {
    if (!data.password) return;

    const result = await resetPassword(data.password);

    addToast({
      type: result.Code === 0 ? 'success' : 'error',
      message: result.Msg,
    });

    if (result.Code === 0) {
      navigate(ROUTES.AUTH.SIGN_IN.$path());
    }
  }

  return (
    <div className='flex flex-1 flex-col'>
      <div className='flex-1 flex flex-col justify-center'>
        {isEmbedded ? (
          <div className='h-30' />
        ) : (
          <BrandLogo
            fetchPriority='high'
            variant='simple-h160'
            className='mx-auto brand-ryuryu:h-40 h-30'
          />
        )}
      </div>
      <div className='mx-12 mb-16 flex-1 flex h-full max-h-60vh 4xl:max-h-40vh flex-col items-stretch first:mt-safe-offset-16'>
        <ForgotPasswordForm
          isLoading={isPending}
          onSubmit={handleSubmit}>
          <button
            type='button'
            className='absolute desktop:static left-4 top-safe-offset-4 btn btn-square desktop:btn-circle btn-ghost desktop:border text-primary-content'
            onClick={() => navigate(-1)}>
            <ArrowLeft2 className='aspect-square size-6' />
          </button>
        </ForgotPasswordForm>
      </div>
    </div>
  );
}
